export const scrollWindowToTop = () => document.documentElement.scrollTo(0, 0)
